import { useTranslation } from 'react-i18next';

import { Carta } from '@/components/tavolo/Carta';
import type { Card } from '@/lib/qcp/protocol';
import { MISURE_CP } from './cartaCp';
import type { TagliaCp } from './cartaCp';

interface PlayingCardProps {
  card?: Card;
  /** Show card back instead of face. */
  faceDown?: boolean;
  /** Render with a bright brand ring to indicate selection / picked-up. */
  selected?: boolean;
  /** Render with a dim brand ring to indicate "placed this hand" (not picked). */
  pending?: boolean;
  /** Render with a red ring — the card being discarded this round. */
  discard?: boolean;
  /** La taglia (v. `cartaCp.ts`). Senza, `mia`. */
  taglia?: TagliaCp;
  /** Un colore per seme invece di rosso e nero (impostazione «Quattro colori»). */
  quattroColori?: boolean;
  /** Sbiadita: le file di chi ha fatto foul. */
  sbiadita?: boolean;
  onClick?: () => void;
}

/**
 * Una carta del tavolo del Chinese Poker: la CARTA del modulo tavolo (`components/tavolo/Carta.tsx`) con la faccia francese, le taglie del CP e l'etichetta del dorso del CP.
 * Il disegno stava qui fino alla PR della Carta generica (kit-giochi S4): e stato spostato nel modulo tavolo SENZA cambiarlo (stesso DOM, carta per carta), e questo e
 * l'involucro che il CP chiama, con le stesse props di prima.
 * ⛔ Solo presentazione: i colori stanno in `lib/tavolo/carta.ts`, le misure in `cartaCp.ts`.
 */
export function PlayingCard({ card, faceDown = false, selected = false, pending = false, discard = false, taglia = 'mia', quattroColori = false, sbiadita = false, onClick }: PlayingCardProps) {
  const { t } = useTranslation('chinesepoker');
  return (
    <Carta
      faccia={card ? { mazzo: 'francese', rango: card.r, seme: card.s } : undefined}
      coperta={faceDown}
      scelta={selected}
      posata={pending}
      scarto={discard}
      sbiadita={sbiadita}
      misure={MISURE_CP[taglia]}
      quattroColori={quattroColori}
      etichettaDorso={t('card.faceDown')}
      onClick={onClick}
    />
  );
}
